import AppointmentsScreen from './AppointmentsScreen';

export default AppointmentsScreen;
